//
//
//
//
//
//
//
//
//
//
//
//

import f_nav_bar from "@/components/nav_bar";
import search from "@/components/search";
import FlexUserList from "@/components/common_flexUserList";
export default {
  components: { f_nav_bar, search, FlexUserList },
  data() {
    return {
      listConfig: {
        pageIndex: 1,
        pageSize: 6,
        pageCount: 1,
      },
      userList: [],
    };
  },


  created () {
    this.getUserList(
      this.listConfig.pageIndex, this.listConfig.pageSize
    )
  },
  computed: {},
  methods: {
    getUserList (pageIndex, pageSize) {
      this.$msg.loading()
      this.$http({
        url: this.$api.MemberReferenceList,
        method: 'post',
        data: { PageIndex: pageIndex, PageSize: pageSize }
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.userList = res.data.data.list.map((item,index) => {
            return { 
              topL: index+1+'.'+item.Name, topR: item.CurrentPoints+'分',
              bottomL: item.Mobile, bottomR: item.CreateOn, avatar: item.HeadImgUrl,
              link: `http://ysl.entfly.com/mSms/Member/Detail?openId=${item.OpenId}`
            }
          })
        }
      })
    }
  }
};
